/* eslint-disable import/prefer-default-export */

export function checkerMap(values) {
  return values.reduce((acc, x) => { acc[x] = true; return acc; }, {});
}
